import axios from "axios";
import endpoints from "../config/endpoints";

const getCookie = (name: string) => {
    const value = `; ${document.cookie}`;
    const parts = value.split(`; ${name}=`);
    if (parts.length === 2) return parts.pop()?.split(';').shift();
}
export async function uploadFileToApi(uploadFile: File | null): Promise<any> {
    if (!uploadFile) throw new Error("Brak pliku");

    const token = getCookie("apinew-token");
    if (!token) throw new Error("Brak tokenu");

    const formData = new FormData();
    formData.append("file", uploadFile);

    const response = await axios.post(endpoints.files.upload, formData, {
        withCredentials: true,
        headers: {
            Authorization: `Bearer ${token}`,
        },
    });

    return response.data;
}
